import { Routes } from '@angular/router';
import { authenticatedGuard } from '@guards/authenticated.guard';

export const projectsRoutes: Routes = [
  {
    canActivate: [authenticatedGuard],
    data: { key: 'projects' },
    loadComponent: () => import('./projects/projects.page').then((m) => m.ProjectsPage),
    path: '',
    title: 'Dashboard Proyectos | Mundo Hogar',
  },
  {
    canActivate: [authenticatedGuard],
    data: { key: 'project-form' },
    loadComponent: () => import('./project-form/project-form.page').then((m) => m.ProjectFormPage),
    path: 'new',
    title: 'Nuevo proyecto | Mundo Hogar',
  },
  {
    canActivate: [authenticatedGuard],
    data: { key: 'project-details' },
    loadComponent: () => import('./project-details/project-details.page').then((m) => m.ProjectDetailsPage),
    path: ':projectId',
    title: 'Dashboard Detalles del proyecto | Mundo Hogar',
  },
  {
    canActivate: [authenticatedGuard],
    data: { key: 'edit-project' },
    loadComponent: () => import('./project-form/project-form.page').then((m) => m.ProjectFormPage),
    path: ':projectId/edit',
    title: 'Editar proyecto | Mundo Hogar',
  },
];
